import OverlayTipsKit from "./OverlayTipsKit"
import $ from "jquery"
import _ from "underscore"
import OverlayTips from "./OverlayTips"
import StateComponent from '../StateComponent'

export default class PageOverlayTipsManager extends StateComponent {

    /**
     * Adds page-specific tips, refreshes them when needed, enables/disables them.
     * @constructor
     */
    constructor() {
        super()

        this._dynamicTips = []
        this._deferredUntilEnabled = []
        this._refreshDynamicTipsDeferred = false
        this._enabledOnce = false
        this._tipsKit = new OverlayTipsKit()
    }

    init() {
        if ($.cookie("at-tips-enabled"))
            this.enable()
        return this
    }

    /**
     * Gets instance of overlay tips manager for current page.
     * @returns {PageOverlayTipsManager}
     */
    static getInstance() {
        if (!PageOverlayTipsManager.instance) PageOverlayTipsManager.setInstance(new PageOverlayTipsManager())
        return this.instance
    }

    /**
     * Sets instance of overlay tips manager for current page.
     * @param instance New instance
     */
    static setInstance(instance) {
        if (PageOverlayTipsManager.instance !== instance) {
            let oldManager = PageOverlayTipsManager.instance
            if (oldManager) {
                instance.enabled = oldManager.enabled
                if (oldManager.enabled) {
                    oldManager._tipsKit.hideAll()
                    instance.enable()
                }
                else {
                    instance._scheduleQueueProcessing()
                }
            }

            PageOverlayTipsManager.instance = instance
        }
    }

    /**
     * Forgets tips enabled status from cookies.
     */
    disableCookie() {
        $.cookie("at-tips-enabled", null, {path: "/", expires: 365})
    }

    /**
     * Remembers tips enabled status in cookies.
     */
    enableCookie() {
        $.cookie("at-tips-enabled", true, {path: "/", expires: 365})
    }

    /**
     * Remembers tips first time status in cookies.
     */
    enableFirstTimeCookie() {
        $.cookie("at-tips-first-time", true, {path: "/", expires: 365})
    }

    /**
     * Remembers tips first time status in cookies.
     */
    disableFirstTimeCookie() {
        $.cookie("at-tips-first-time", null, {path: "/", expires: 365})
    }

    /**
     * Remembers a state, which prevents tips from showing immediately.
     */
    enableShowLater() {
        this._showLater = true
    }

    showFirstTimeTips() {
        this._tipsKit.showAll()
    }

    disableMenuIcon() {
        $(".popup_menu_button_tips").children(".popup_menu_icon").removeClass("tips_icon_light_on")
    }

    enableMenuIcon() {
        $(".popup_menu_button_tips").children('.popup_menu_icon').addClass("tips_icon_light_on")
    }

    /**
     * Base function, which adds initial tips, usually on page load.
     */
    addBaseTips() {
        if ($.cookie("at-tips-first-time")) {
            this._firstTimeTip = this.add($(".popup_menu_button_tips"), {
                messageKey: "tips.toggle_tips",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -20,
                offsetY: 10,
                extraClass: "toggleTipsTipZindex"
            })

            if (!this._showLater)
                this.disableFirstTimeCookie()
        }
    }

    /**
     * Toggles tips enabled status.
     */
    toggle() {
        if (this.enabled)
            this.disable()
        else
            this.enable()
    }

    /**
     * Disables all tips on the page, hiding them,
     * and updates navigation tip button status.
     */
    disable() {
        this.enabled = false
        this.disableCookie()

        if (this._firstTimeTip) {
            this._tipsKit.remove(this._firstTimeTip.id)
            this._firstTimeTip = null
        }

        this._tipsKit.hideAll()
        this.disableMenuIcon()
    }

    /**
     * Enables all tips on the page, showing them,
     * and updates navigation tip button status.
     */
    enable() {
        this.enabled = true
        this.enableCookie()

        if (!this._enabledOnce) {
            this.addBaseTips()
            for (var i = 0; i < this._deferredUntilEnabled.length; i++)
                this._deferredUntilEnabled[i].call(this)
            this._enabledOnce = true
        }
        else {
            this._tipsKit.showAll()
            this._scheduleQueueProcessing()
        }

        if (this._refreshDynamicTipsDeferred)
            this.refreshDynamicTips()

        this.enableMenuIcon()
    }

    _scheduleQueueProcessing() {
        if (!this._tipsKit.isQueueProcessed())
            this._tipsKit.scheduleQueueProcessing()
    }

    /**
     * Add static or dynamic tip to specified element.
     * @param relative Relative jQuery element or a function returning jQuery element.
     *                 If a function is specified, added tip will be dynamic.
     * @param config OverlayTips config.
     */
    add(relative, config) {
        if (_.isFunction(relative)) {
            // If relative element is a function, this is a dynamic tip.
            // Such tips are re-calculated each time refreshDynamicTips() is called.
            const relativeCalculated = relative()
            const configCalculated = (relativeCalculated.config) ? relativeCalculated.config : config
            const elemCalculated = (relativeCalculated.element) ? relativeCalculated.element : relativeCalculated
            this._dynamicTips.push({
                element: elemCalculated,
                relativeFunction: relative,
                config: configCalculated
            })
            relative = elemCalculated
            config = configCalculated
        }

        return this._add(relative, config)
    }

    /**
     * Re-evaluates every dynamic tip, deleting them or moving to new relatives if necessary.
     */
    refreshDynamicTips(animated) {
        if (_.isUndefined(animated))
            animated = true

        if (!this.enabled) {
            this._refreshDynamicTipsDeferred = true
            return
        }

        const self = this
        _.each(this._dynamicTips, function(dt) {
            // Find dynamic tip element in DOM
            const tip = document.getElementById("overlayTip" + dt.config.id)
            const newRelative = dt.relativeFunction()
            const newElementCalculated = (newRelative.element) ? newRelative.element : newRelative
            const newConfigCalculated = (newRelative.config) ? newRelative.config : dt.config
            const oldElementCalculated = dt.element
            let addAgain = false
            if (tip) {
                // Tip element exists, check if its relative is still valid
                if (oldElementCalculated[0] != newElementCalculated[0] || !_.isMatch(dt.config, newConfigCalculated)) {
                    // Old relative is no longer valid, so we remove the tip and ask to re-add it
                    self._tipsKit.remove(dt.config.id)
                    addAgain = true
                }
            }
            else {
                // Tip element is no longer in DOM, so we ask to re-add it
                addAgain = true
            }

            // Attempt to add the tip again. If newRelative is empty, nothing will be added
            if (addAgain) {
                dt.element = newElementCalculated
                // If we don't clone the object, then we can get few instances of one object in queue
                dt.config = _.clone(newConfigCalculated)
                dt.config.refreshAnimated = animated
                self._add(dt.element, dt.config)
            }
        })
    }

    deferUntilEnabled(f) {
        if (this.enabled)
            f.call(this)
        else
            this._deferredUntilEnabled.push(f)
    }

    /**
     * Adds new tip with specified config to the element.
     * @param relative Relative jQuery element.
     * @param config OverlayTips config.
     * @private
     */
    _add(relative, config) {
        const $el = relative.first()
        if ($el.length == 0)
            return

        // config.show is a dynamic parameter
        config.show = this.enabled && !this._showLater

        config.relativeTo = $el
        return this._tipsKit.enqueueTip(config)
    }

    repositionOutsideTips() {
        this._tipsKit.repositionOutsideTips()
    }
}



// WEBPACK FOOTER //
// ./web/js/tips/PageOverlayTipsManager.js